import {ActionEvent} from "@hotwired/stimulus";

export const isActionEvent = (value: any): value is ActionEvent => {
    return value instanceof Event && 'params' in value && typeof (value as any).params !== 'undefined';
}

